import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import React, { useEffect } from 'react';
import ProfileEditIcon from '../Icons/ProfileEditIcon';
import Button from '@/shared/Button';
import DeleteIcon from '../Icons/DeleteIcon';
import useModalToggle from '@/hooks/useModalToggle';
import Modal from '@/shared/crisp/Modal';
import { deleteProfileInfo } from '@/actions/ecom/profileV2';
import useTriggerRequest from '@/hooks/useTriggerRequest';
import useToast from '@/hooks/useToast';
import {
  D365_USER_ID,
  PROFILE_FIELD_LABELS,
  PROFILE_MODAL_STYLING,
  SHOW_PROFILE_TOAST,
} from '@/constants/profileManagement';
import classNames from 'classnames';
import Cookies from '@/utils/cookie';

function FormFields({
  showEditIcon = false,
  showDeleteIcon = false,
  label,
  onEditClick,
  inputValue,
  isEditAllowed,
  contactId,
}: any) {
  const { open, openModal, closeModal } = useModalToggle(false);
  const { triggerDefault } = useToast();

  const fetch = (...args: any) => deleteProfileInfo.apply(null, args);

  const { isLoading, isError, promisifyTrigger, error } = useTriggerRequest({ fetch });

  if (!Cookies.get(D365_USER_ID) && label !== PROFILE_FIELD_LABELS.PRIMARY_USER)
    isEditAllowed = false;

  useEffect(() => {
    if (isError && error?.error) {
      triggerDefault({
        message: error?.error,
        durationInms: 5000,
      });
    }
  }, [isError, error?.error]);

  const handledDeleteClick = () => {
    openModal();
  };

  const handleDeleteConfirm = async () => {
    await promisifyTrigger({
      contactId,
      isEmail: label === 'EMAIL',
    });
    sessionStorage.setItem(SHOW_PROFILE_TOAST, 'true');
    window.location.reload();
  };

  if (!inputValue) return null;

  return (
    <Div className="py-s4 flex justify-between">
      <Div className="flex flex-col gap-s2">
        <Paragraph className="text-xs-desktop text-cti-tertiary">{label}</Paragraph>
        <Paragraph className="text-body-lg text-cti-primary">{inputValue}</Paragraph>
      </Div>
      <Div className="flex gap-s3">
        {showEditIcon && isEditAllowed ? (
          <Button
            theme="none"
            className=" w-9 h-9 flex rounded-full border items-center justify-center"
            onClick={onEditClick}
          >
            <ProfileEditIcon />
          </Button>
        ) : null}
        {showDeleteIcon && isEditAllowed ? (
          <Button
            theme="none"
            className="w-9 h-9 flex rounded-full border items-center justify-center "
            onClick={handledDeleteClick}
          >
            <DeleteIcon />
          </Button>
        ) : null}

        {open ? (
          <Modal
            id="non-available-products"
            open={open}
            onClose={closeModal}
            classNames="w-full bottom-0 fixed md:bottom-auto md:relative md:w-[416px] shadow-xbold"
          >
            <Div
              className={classNames(
                ' md:p-10 md:bg-white md:rounded-xl flex flex-col gap-s8 md:gap-s9 md:border md:border-core-outline-subtle',
                [PROFILE_MODAL_STYLING.className],
              )}
            >
              <Paragraph className="text-h-2">Are you sure you want to delete?</Paragraph>
              <Div className="flex justify-between items-center gap-s3">
                <Button
                  theme="secondary"
                  className="w-full"
                  onClick={handleDeleteConfirm}
                  isLoading={isLoading}
                >
                  YES
                </Button>
                <Button theme="primary" className="w-full" onClick={() => closeModal()}>
                  NO
                </Button>
              </Div>
            </Div>
          </Modal>
        ) : null}
      </Div>
    </Div>
  );
}

export default FormFields;
